@if (title) {
  <div class="modal-header">
    <div class="d-flex align-items-center">
      <h4 class="modal-title" id="modal-basic-title">
        {{ title }}
      </h4>
    </div>
    <ideapa-icon-button
      icon="close"
      cssClasses="text-primary hover-bg-primary"
      (clicked)="cancel()"
      >
    </ideapa-icon-button>
  </div>
}
<div class="modal-body">
  <div class="mt-2">
    <div class="message" [innerHTML]="message"></div>
  </div>
</div>
<div class="modal-footer">
  @if (cancelText) {
    <ideapa-button
      class="me-2"
      [cssClasses]="'btn-outline-primary'"
      [text]="cancelText"
      (clicked)="cancel()"
    ></ideapa-button>
  }
  <ideapa-button
    [cssClasses]="'btn-primary'"
    [text]="okText"
    (clicked)="confirm()"
  ></ideapa-button>
</div>
